import { defineMessages, MessageDescriptor } from 'react-intl';

import { OrganizationClientsKind } from './types';

export const organizationClientsTabMessages: Record<
  OrganizationClientsKind,
  MessageDescriptor
> = defineMessages({
  dso: {
    id: 'organizationDSOClients.tab',
    defaultMessage: 'DSO Clients',
  },
  distributor: {
    id: 'organizationDistributorClients.tab',
    defaultMessage: 'Distributor Clients',
  },
});

export const organizationClientsEmptyMessages: Record<
  OrganizationClientsKind,
  MessageDescriptor
> = defineMessages({
  dso: {
    id: 'organizationDSOClients.empty',
    defaultMessage: 'No DSO clients',
  },
  distributor: {
    id: 'organizationDistributorClients.empty',
    defaultMessage: 'No distributor clients',
  },
});
